module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"goodsType":"Goods Type","selectGoodsType":"Select goods type"},"no":{"goodsType":"Godstype","selectGoodsType":"Velg godstype"}}')
  delete Component.options._Ctor
}
